import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import PortfolioPage from '../PortfolioPage/PortfolioPage';
import PortfolioSinglePage from '../PortfolioSinglePage/PortfolioSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import ContactPage from '../ContactPage/ContactPage';
import CaseStudy from '../PortfolioPage/CaseStudyPage';
import CaseStudySinglePage from '../PortfolioSinglePage/CaseStudySinglePage';
import CareerPage from '../Career/career';
import ReviewForm from '../../components/ContactFrom/ReviewForm';
import Privacy from '../TermsandCondition/Privacy';
import Term from '../TermsandCondition/Term';
import AdminRedirect from '../AdminRoute/AdminRedirect';
import NotFound from '../404/404';
import IndustriesSinglePage from '../Industry/Industry';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="case-study" element={<CaseStudy />} />
          <Route path="portfolio/:id" element={<PortfolioSinglePage />} />
          <Route path="case-study/:id" element={<CaseStudySinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="services" element={<ServicePage />} />
          <Route path=":slug" element={<ServiceSinglePage />} />
          <Route path="industries/:slug" element={<IndustriesSinglePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:id" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="career" element={<CareerPage />} />
          <Route path="review" element={<ReviewForm />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="terms-and-conditions" element={<Term />} />
          <Route path="/admin" element={<AdminRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
